__turbopack_context__.v({
  "blink": "Legal-module-scss-module__8ycRnG__blink",
  "content": "Legal-module-scss-module__8ycRnG__content",
  "legalPage": "Legal-module-scss-module__8ycRnG__legalPage",
  "title": "Legal-module-scss-module__8ycRnG__title",
});
